export const DEACTIVATED_STUDENTS_LOAD = 'DEACTIVATED_STUDENTS_LOAD'
export const DEACTIVATED_STUDENTS_LOAD_PENDING =
  'DEACTIVATED_STUDENTS_LOAD_PENDING'
export const DEACTIVATED_STUDENTS_LOAD_FULFILLED =
  'DEACTIVATED_STUDENTS_LOAD_FULFILLED'
export const DEACTIVATED_STUDENTS_LOAD_REJECTED =
  'DEACTIVATED_STUDENTS_LOAD_REJECTED'
